import { Model } from '@/models/Model';
export class SubjectLabelCategory extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SubjectLabelCategory';
        this.$endpoint = '/tag-categories';
        this.$fillable = [
            'label',
        ];
    }
}
